import { getLocalStorage } from '../helpers'

const initialState = {
  // STORED
  user: getLocalStorage('user',
    null
  ),
  monitoring: getLocalStorage('monitoring', {
    data: {},
    lastUpdate: null
  }),
  herd: getLocalStorage('herd', {
    data: [],
    lastUpdate: null
  }),
  objects: getLocalStorage('objects', {
    data: [],
    lastUpdate: null
  }),
  cowSearch: getLocalStorage('cowSearch', {
    data: [],
    lastUpdate: null
  }),
  sort: getLocalStorage('sort', {}),
  group: getLocalStorage('group', {
    data: [],
    selected: '',
    lastUpdate: null
  }),
  // Moving between cows feature
  cowsList: getLocalStorage('cowsList', []),
  // Moving between groups feature
  groupsList: getLocalStorage('groupsList', []),
  // Moving between zones feature
  zonesList: getLocalStorage('zonesList', []),
  // NOT STORED
  app: {
    online: navigator.onLine,
    delays: false,
    alerts: {
      data: {},
      lastUpdate: null
    }
  },
  monitoring_data: {
    data: null,
    lastUpdate: null
  },
  timestamp: 0,
  timestampDelay: 10000
}

const types = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  SET_LASTUPDATE: 'SET_LASTUPDATE',
  SET_MONITORING: 'SET_MONITORING',
  SET_HERD: 'SET_HERD',
  SET_OBJECTS: 'SET_OBJECTS',
  SET_COWSEARCH: 'SET_COWSEARCH',
  SET_MONITORING_DATA: 'SET_MONITORING_DATA',
  SET_ONLINE: 'SET_ONLINE',
  SET_DELAYS: 'SET_DELAYS',
  SET_ALERTS: 'SET_ALERTS',
  SET_SORT: 'SET_SORT',
  SET_SELECTED_GROUP: 'SET_SELECTED_GROUP',
  SET_COWS_LIST: 'SET_COWS_LIST',
  SET_GROUPS_LIST: 'SET_GROUPS_LIST',
  SET_ZONES_LIST: 'SET_ZONES_LIST',
  SET_TIMESTAMP: 'SET_TIMESTAMP',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload,
      }
    case types.LOGIN_FAILURE:
      return {
        ...state,
        user: null,
      }
    case types.SET_MONITORING:
      return {
        ...state,
        monitoring: action.payload,
      }
    case types.SET_HERD:
      return {
        ...state,
        herd: action.payload,
      }
    case types.SET_OBJECTS:
      return {
        ...state,
        objects: action.payload,
      }
    case types.SET_COWSEARCH:
      return {
        ...state,
        cowSearch: action.payload,
      }
    case types.SET_MONITORING_DATA:
      return {
        ...state,
        monitoring_data: action.payload,
      }
    case types.SET_MANAGE:
      return {
        ...state,
        manage: action.payload
      }
    case types.SET_ONLINE:
      return {
        ...state,
        app: {
          ...state.app,
          online: action.payload,
        }
      }
    case types.SET_DELAYS:
      return {
        ...state,
        app: {
          ...state.app,
          delays: action.payload,
        }
      }
    case types.SET_ALERTS:
      return {
        ...state,
        app: {
          ...state.app,
          alerts: action.payload
        }
      }
    case types.SET_SORT:
      return {
        ...state,
        sort: {
          ...state.sort,
          ...action.payload
        }
      }
    case types.SET_SELECTED_GROUP: {
      return {
        ...state,
        group: {
          ...state.group,
          selected: action.payload
        }
      }
    }
    case types.SET_COWS_LIST: {
      return {
        ...state,
        cowsList: action.payload
      }
    }
    case types.SET_GROUPS_LIST: {
      return {
        ...state,
        groupsList: action.payload
      }
    }
    case types.SET_ZONES_LIST: {
      return {
        ...state,
        zonesList: action.payload
      }
    }
      case types.SET_TIMESTAMP: {
      return {
        ...state,
        timestamp: action.payload
      }
    }
    default:
      throw new Error('Unexpected action')
  }
}

export { initialState, types, reducer }
